import React from 'react';

const AIChatMockup = () => {
  return (
    <div className="mockup-container ai-mockup">
      <div className="mockup-header-bar">
        <div className="ai-status">
          <div className="pulse-dot"></div>
          <span>IA de Gestión Activa</span>
        </div>
      </div>

      <div className="chat-window">
        <div className="msg bot">
          <div className="avatar-ai">AI</div>
          <div className="bubble">
            Hola, soy tu asistente de gestión. He detectado que el **Lote #0085** está por debajo del umbral mínimo (120g). ¿Quieres que genere una alerta de reposición?
          </div>
        </div>
        <div className="msg user">
          <div className="bubble">Sí, y analízame la tendencia de consumo de este mes.</div>
        </div>
        <div className="msg bot">
          <div className="avatar-ai">AI</div>
          <div className="bubble">
            <p>Analizando datos... 📈</p>
            <p>Este mes el consumo ha subido un **14%** respecto al mes anterior. Las horas de mayor demanda son los Viernes entre las 18:00 y las 21:00.</p>
          </div>
        </div>
      </div>

      <div className="input-sim">
        <div className="input-box">Escribe una pregunta...</div>
        <div className="send-btn"></div>
      </div>

      <style dangerouslySetInnerHTML={{ __html: `
        .ai-mockup { background: #111827; border-radius: 12px; padding: 24px; color: white; display: flex; flex-direction: column; gap: 20px; box-shadow: 0 20px 40px rgba(0,0,0,0.4); }
        .ai-status { display: flex; align-items: center; gap: 8px; font-size: 11px; font-weight: 600; color: #10b981; }
        .pulse-dot { width: 8px; height: 8px; background: #10b981; border-radius: 50%; animation: pulse 2s infinite; }
        @keyframes pulse { 0% { opacity: 0.4; } 50% { opacity: 1; } 100% { opacity: 0.4; } }
        
        .chat-window { flex: 1; display: flex; flex-direction: column; gap: 16px; min-height: 240px; }
        .msg { display: flex; gap: 12px; align-items: flex-end; }
        .msg.user { flex-direction: row-reverse; }
        
        .avatar-ai { width: 28px; height: 28px; background: #059669; border-radius: 8px; display: flex; align-items: center; justify-content: center; font-size: 10px; font-weight: 700; }
        .bubble { padding: 12px 16px; border-radius: 12px; font-size: 13px; line-height: 1.5; max-width: 85%; }
        .bot .bubble { background: #1f2937; color: #e5e7eb; border-bottom-left-radius: 2px; }
        .user .bubble { background: #059669; color: white; border-bottom-right-radius: 2px; }
        
        .input-sim { display: flex; gap: 12px; align-items: center; background: #1f2937; padding: 8px 16px; border-radius: 99px; }
        .input-box { flex: 1; font-size: 12px; color: #9ca3af; }
        .send-btn { width: 20px; height: 20px; background: #059669; border-radius: 50%; }
      `}} />
    </div>
  );
};

export default AIChatMockup;
